<template>
  <div>
    <v-expansion-panels accordion multiple class="custom-panel mt-5">
      <v-expansion-panel>
        <v-expansion-panel-header> รูปแบบ Header </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card v-show="!webform_theme.logo" class="pl-2" flat>
            <input
              ref="logoimage"
              type="file"
              accept="image/*"
              @change="LogoImage()"
              class="d-none"
            />
            <v-btn @click="$refs.logoimage.click()">
              <v-icon small class="mr-2">mdi-image</v-icon>
              เลือกรูปภาพ
            </v-btn>
          </v-card>
          <v-card v-show="webform_theme.logo" class="pl-2" flat>
            <v-card flat>
              <v-card-title class="pa-1">
                <!-- <v-btn icon @click="PopupCrop">
                  <v-icon size="20">crop</v-icon>
                </v-btn>
                <CropImage
                  :image_url="webform_theme.logo_image.url"
                  filepath="webform_theme"
                  ref="cropimage"
                  @croped="(img) => (webform_theme.logo_image.url = img)"
                /> -->
                <v-spacer></v-spacer>
                <v-btn icon color="#DE4F3B" @click="ClearLogoImage"
                  ><v-icon>clear</v-icon></v-btn
                >
              </v-card-title>
              <v-card-text class="d-flex justify-center">
                <img :src="webform_theme.logo_image.url" width="100" />
              </v-card-text>
              <v-card-text class="pb-0">
                <v-btn
                  color="primary"
                  outlined
                  block
                  @click="$refs.logoimage.click()"
                  >เปลี่ยนรูป</v-btn
                >
              </v-card-text>
              <v-card-text class="py-0">
                <v-row class="my-3">
                  <v-col cols="12" class="grow">
                    <v-select
                      v-model="logo_type_selected"
                      :items="logo_type"
                      label="รูปแบบ Header"
                      outlined
                      dense
                      attach
                      hide-details
                      item-text="text"
                      item-value="value"
                      @change="LogoType"
                    ></v-select
                  ></v-col>
                </v-row>
              </v-card-text>
              <v-card-text class="pt-0" v-if="logo_type_selected === 'normal'">
                <v-radio-group
                  v-model="webform_theme.logo_image.rounded"
                  row
                  hide-details=""
                >
                  <template v-slot:label> รูปร่าง </template>
                  <v-radio value="circle">
                    <template v-slot:label>
                      <div>วงกลม</div>
                    </template>
                  </v-radio>
                  <v-radio value="0">
                    <template v-slot:label>
                      <div>สี่เหลี่ยม</div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <v-radio-group
                  v-model="webform_theme.logo_image.margin"
                  row
                  hide-details=""
                >
                  <template v-slot:label> margin </template>
                  <v-radio :value="true">
                    <template v-slot:label>
                      <div>มี</div>
                    </template>
                  </v-radio>
                  <v-radio :value="false">
                    <template v-slot:label>
                      <div>ไม่มี</div>
                    </template>
                  </v-radio>
                </v-radio-group>
                <v-row no-gutters align="center" class="mt-3">
                  <v-col cols="2">ขนาด : </v-col>
                  <v-col cols="10">
                    <v-slider
                      v-model="LogoSizeChange"
                      min="1"
                      max="100"
                      step="1"
                      hide-details=""
                      class="mt-1"
                    >
                      <template #append>
                        <v-btn class="mt-n1" @click="LZoomIn" icon
                          ><v-icon size="32">mdi-image-area</v-icon></v-btn
                        >
                      </template>
                      <template #prepend>
                        <v-btn class="mt-n1" @click="LZoomOut" icon>
                          <v-icon size="20">mdi-image-area</v-icon></v-btn
                        >
                      </template>
                    </v-slider>
                  </v-col>
                </v-row>
                <v-radio-group
                  v-model="webform_theme.logo_image.align"
                  class="mt-1"
                  hide-details=""
                >
                  <template v-slot:label> ระยะขอบบน </template>
                  <v-radio value="start">
                    <template v-slot:label>
                      <div>ชิดขอบบน</div>
                    </template>
                  </v-radio>
                  <v-radio value="center">
                    <template v-slot:label>
                      <div>ตรงกลาง</div>
                    </template>
                  </v-radio>
                  <v-radio value="end">
                    <template v-slot:label>
                      <div>ชิดขอบล่าง</div>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-card-text>
              <div v-if="logo_type_selected === 'banner'">
                <v-card-text class="py-0"> ขนาดรูป Banner </v-card-text>
                <v-card-text class="pl-2">
                  <v-slider
                    v-model="BannerSizeChange"
                    min="50"
                    max="100"
                    step="1"
                    hide-details=""
                  >
                    <template #append>
                      <v-btn class="mt-n1" @click="BZoomIn" icon
                        ><v-icon size="32">mdi-image-area</v-icon></v-btn
                      >
                    </template>
                    <template #prepend>
                      <v-btn class="mt-n1" @click="BZoomOut" icon>
                        <v-icon size="20">mdi-image-area</v-icon></v-btn
                      >
                    </template>
                  </v-slider>
                </v-card-text>
              </div>
            </v-card>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <div class="my-5">รูปแบบธีม</div>
    <v-expansion-panels accordion multiple>
      <v-expansion-panel>
        <v-expansion-panel-header> พื้นหลัง </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="pa-0"> สีพื้นหลัง </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.bg_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> รูปภาพพื้นหลัง </v-card-text>
            <v-card-text class="px-0">
              <v-card v-show="!webform_theme.bg_image" class="pl-2" flat>
                <input
                  ref="bgimage"
                  type="file"
                  accept="image/*"
                  @change="BGImage()"
                  class="d-none"
                />
                <v-btn @click="$refs.bgimage.click()">
                  <v-icon small class="mr-2">mdi-image</v-icon>
                  เลือกรูปภาพ
                </v-btn>
              </v-card>
              <v-card v-show="webform_theme.bg_image" class="pl-2" flat>
                <v-card>
                  <v-card-title class="pa-1">
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      color="#DE4F3B"
                      @click="webform_theme.bg_image = false"
                      ><v-icon>clear</v-icon></v-btn
                    >
                  </v-card-title>
                  <v-card-text class="d-flex justify-center">
                    <img :src="webform_theme.bg_image_url" width="100" />
                  </v-card-text>
                  <v-card-text>
                    <v-btn
                      color="primary"
                      outlined
                      block
                      @click="$refs.bgimage.click()"
                      >เปลี่ยนรูป</v-btn
                    >
                  </v-card-text>
                  <v-card-text>
                    <v-radio-group
                      v-model="webform_theme.bg_repeat"
                      hide-details=""
                    >
                      <template v-slot:label> ปรับรูปภาพพื้นหลัง </template>
                      <v-radio value="repeat">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำปกติ</div>
                        </template>
                      </v-radio>
                      <v-radio value="repeat-x">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำไปทางแนวนอน</div>
                        </template>
                      </v-radio>
                      <v-radio value="repeat-y">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำไปทางแนวตั้ง</div>
                        </template>
                      </v-radio>
                      <v-radio value="no-repeat">
                        <template v-slot:label>
                          <div>รูปภาพไม่ซ้ำ</div>
                        </template>
                      </v-radio>
                      <v-radio value="space">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำแบบมีช่องว่าง</div>
                        </template>
                      </v-radio>
                      <v-radio value="round">
                        <template v-slot:label>
                          <div>รูปภาพซ้ำแบบพอดีหน้าจอ</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="webform_theme.bg_size"
                      hide-details=""
                    >
                      <template v-slot:label> รูปแบบภาพพื้นหลัง </template>
                      <v-radio value="auto">
                        <template v-slot:label>
                          <div>อัตโนมัติ</div>
                        </template>
                      </v-radio>
                      <v-radio value="100% 100%">
                        <template v-slot:label>
                          <div>พอดีหน้าจอ</div>
                        </template>
                      </v-radio>
                      <v-radio value="cover">
                        <template v-slot:label>
                          <div>เต็มจอตามความยาวรูปภาพ</div>
                        </template>
                      </v-radio>
                      <v-radio value="contain">
                        <template v-slot:label>
                          <div>เต็มจอตามความสูงรูปภาพ</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="webform_theme.bg_position_x"
                      hide-details=""
                    >
                      <template v-slot:label>
                        การจัดวางตามแกน x (แนวนอน)
                      </template>
                      <v-radio value="left">
                        <template v-slot:label>
                          <div>ซ้าย</div>
                        </template>
                      </v-radio>
                      <v-radio value="center">
                        <template v-slot:label>
                          <div>กลาง</div>
                        </template>
                      </v-radio>
                      <v-radio value="right">
                        <template v-slot:label>
                          <div>ขวา</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                    <v-radio-group
                      v-model="webform_theme.bg_position_y"
                      hide-details=""
                    >
                      <template v-slot:label>
                        การจัดวางตามแกน y (แนวตั้ง)
                      </template>
                      <v-radio value="top">
                        <template v-slot:label>
                          <div>บน</div>
                        </template>
                      </v-radio>
                      <v-radio value="center">
                        <template v-slot:label>
                          <div>กลาง</div>
                        </template>
                      </v-radio>
                      <v-radio value="bottom">
                        <template v-slot:label>
                          <div>ล่าง</div>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-card-text>
                </v-card>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header> สีพื้นหลังหัวข้อ </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-color-picker
            v-model="webform_theme.header_bg"
            class="my-6"
          ></v-color-picker>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header> สีข้อความหัวข้อ </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-color-picker
            v-model="webform_theme.header_text"
            class="my-6"
          ></v-color-picker>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header> คำถาม </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="pa-0"> สีพื้นหลังคำถาม </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.q_bgcolor"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> สีข้อความคำถาม </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.q_text_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> สีขอบคำถาม </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.q_border_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-row no-gutters align="center">
              <v-col cols="4">ขอบความหนา : </v-col>
              <v-col cols="8">
                <v-slider
                  v-model="QuestionThickChange"
                  min="1"
                  max="100"
                  step="1"
                  hide-details=""
                >
                  <template #append>
                    <v-btn @click="QZoomIn" icon
                      ><v-icon>mdi-magnify-plus-outline</v-icon></v-btn
                    >
                  </template>
                  <template #prepend>
                    <v-btn @click="QZoomOut" icon>
                      <v-icon>mdi-magnify-minus-outline</v-icon></v-btn
                    >
                  </template>
                </v-slider>
              </v-col>
            </v-row>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header> คำตอบ </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="pa-0"> สีพื้นหลังคำตอบ </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.ans_bgcolor"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> สีข้อความคำตอบ </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.ans_text_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> สีคำตอบ </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.ans_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0"> สีขอบคำตอบ </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.ans_border_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-row no-gutters align="center">
              <v-col cols="4">ขอบความหนา : </v-col>
              <v-col cols="8">
                <v-slider
                  v-model="AnswerThickChange"
                  min="1"
                  max="100"
                  step="1"
                  hide-details=""
                >
                  <template #append>
                    <v-btn @click="AZoomIn" icon
                      ><v-icon>mdi-magnify-plus-outline</v-icon></v-btn
                    >
                  </template>
                  <template #prepend>
                    <v-btn @click="AZoomOut" icon>
                      <v-icon>mdi-magnify-minus-outline</v-icon></v-btn
                    >
                  </template>
                </v-slider>
              </v-col>
            </v-row>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header> ปุ่มถัดไป </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="px-0"> ข้อความ </v-card-text>
            <v-card-text class="pa-0">
              <v-text-field
                v-model="webform_theme.button.text"
                outlined
                maxlength="16"
                counter="16"
                dense
              ></v-text-field>
            </v-card-text>
            <v-card-text class="px-0 pt-0">
              <v-radio-group
                v-model="webform_theme.button.bt_texttype"
                hide-details=""
                @change="NextButtonUI"
              >
                <template v-slot:label> รูปแบบปุ่ม </template>
                <v-radio value="button">
                  <template v-slot:label>
                    <div>แบบที่ 1</div>
                  </template>
                </v-radio>
                <v-radio value="text">
                  <template v-slot:label>
                    <div>แบบที่ 2</div>
                  </template>
                </v-radio>
                <v-radio value="outlined">
                  <template v-slot:label>
                    <div>แบบที่ 3</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-text
              v-show="webform_theme.button.bt_texttype === 'button'"
              class="pa-0"
            >
              สีพื้นหลังปุ่ม
            </v-card-text>
            <v-card-text
              v-show="webform_theme.button.bt_texttype === 'button'"
              class="pa-0"
            >
              <v-color-picker
                v-model="webform_theme.button.bg_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0">
              สีข้อความ / สีเส้นขอบของปุ่ม
            </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.button.text_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header> ปุ่มเริ่มใหม่ </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card flat>
            <v-card-text class="px-0"> ข้อความ </v-card-text>
            <v-card-text class="pa-0">
              <v-text-field
                v-model="webform_theme.restart_button.text"
                outlined
                maxlength="16"
                counter="16"
                dense
              ></v-text-field>
            </v-card-text>
            <v-card-text class="px-0 pt-0">
              <v-radio-group
                v-model="webform_theme.restart_button.bt_texttype"
                hide-details=""
                @change="BackButtonUI"
              >
                <template v-slot:label> รูปแบบปุ่ม </template>
                <v-radio value="button">
                  <template v-slot:label>
                    <div>แบบที่ 1</div>
                  </template>
                </v-radio>
                <v-radio value="text">
                  <template v-slot:label>
                    <div>แบบที่ 2</div>
                  </template>
                </v-radio>
                <v-radio value="outlined">
                  <template v-slot:label>
                    <div>แบบที่ 3</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card-text>
            <v-card-text
              v-show="webform_theme.restart_button.bt_texttype === 'button'"
              class="pa-0"
            >
              สีพื้นหลังปุ่ม
            </v-card-text>
            <v-card-text
              v-show="webform_theme.restart_button.bt_texttype === 'button'"
              class="pa-0"
            >
              <v-color-picker
                v-model="webform_theme.restart_button.bg_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
            <v-card-text class="pa-0">
              สีข้อความ / สีเส้นขอบของปุ่ม
            </v-card-text>
            <v-card-text class="pa-0">
              <v-color-picker
                v-model="webform_theme.restart_button.text_color"
                class="my-6"
              ></v-color-picker>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="qselect_type === 'fixtext'">
        <v-expansion-panel-header>
          การแสดงผลปุ่มตัวเลือกเดียว
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-radio-group v-model="webform_theme.radio_row" row hide-details="">
            <v-radio :value="false">
              <template v-slot:label>
                <div>แนวตั้ง</div>
              </template>
            </v-radio>
            <v-radio :value="true">
              <template v-slot:label>
                <div>แนวนอน</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="qselect_type === 'multiselect'">
        <v-expansion-panel-header>
          การแสดงผลปุ่มหลายตัวเลือก
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-radio-group
            v-model="webform_theme.checkbox_row"
            row
            hide-details=""
          >
            <v-radio :value="false">
              <template v-slot:label>
                <div>แนวตั้ง</div>
              </template>
            </v-radio>
            <v-radio :value="true">
              <template v-slot:label>
                <div>แนวนอน</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import Swal from "sweetalert2";
// import CropImage from "./CropImage.vue";
const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};
export default {
  props: [
    "qselect_type",
    "webform_theme",
    "logo",
    "logo_image",
    "checkbox_row",
    "radio_row",
  ],
  components: {
    // CropImage,
  },
  data() {
    return {
      imgURL: "",
      resultURL: "",
      fileName: "",
      logo_size: 100,
      banner_size: 100,
      q_thick: 100,
      a_thick: 100,
      logo_type_selected: "normal",
      logo_type: [
        {
          text: "โลโก้",
          value: "normal",
        },
        {
          text: "แบนเนอร์",
          value: "banner",
        },
      ],
    };
  },
  mounted() {
    this.logo_size = Math.floor(
      (this.webform_theme.logo_image.size / 130) * 100
    );
    if (Object.keys(this.webform_theme).includes("logo_type")) {
      this.logo_type_selected = this.webform_theme.logo_type;
    } else {
      this.webform_theme.logo_type = "normal";
      this.logo_type_selected = "normal";
    }
    if (Object.keys(this.webform_theme).includes("banner_size")) {
      this.banner_size = this.webform_theme.banner_size;
    } else {
      this.webform_theme.banner_size = 100;
    }
    this.q_thick = Math.floor((this.webform_theme.q_border_px / 50) * 100);
    this.a_thick = Math.floor((this.webform_theme.ans_border_px / 50) * 100);
    if (this.webform_theme.logo) {
      this.fileName = this.webform_theme.logo_image.url.match(
        /([\w\d_-]*)\.?[^\\/]*$/i
      )[1];
      getBase64FromUrl(this.webform_theme.logo_image.url).then((result) => {
        this.imgURL = result;
      });
    }
  },
  computed: {
    QuestionThickChange: {
      set: function (val) {
        this.q_thick = val;
        this.webform_theme.q_border_px = (val / 100) * 50;
      },
      get: function () {
        return this.q_thick;
      },
    },
    AnswerThickChange: {
      set: function (val) {
        this.a_thick = val;
        this.webform_theme.ans_border_px = (val / 100) * 50;
      },
      get: function () {
        return this.a_thick;
      },
    },
    LogoSizeChange: {
      set: function (val) {
        this.logo_size = val;
        this.webform_theme.logo_image.size = (val / 100) * 130;
      },
      get: function () {
        return this.logo_size;
      },
    },
    BannerSizeChange: {
      set: function (val) {
        if (this.banner_size === "100%") {
          this.banner_size = 100;
        } else {
          this.banner_size = val;
          this.webform_theme.logo = false;
          this.webform_theme.banner_size = val;
          this.webform_theme.logo = true;
        }
      },
      get: function () {
        return this.banner_size;
      },
    },
  },
  methods: {
    PopupCrop() {
      this.$refs.cropimage.OpenPopupCrop(this.imgURL, this.fileName);
    },
    LogoType(event) {
      this.webform_theme.logo = false;
      this.webform_theme.logo_type = event;
      this.webform_theme.logo = true;
    },
    QZoomOut() {
      this.QuestionThickChange = --this.q_thick;
    },
    QZoomIn() {
      this.QuestionThickChange = ++this.q_thick;
    },
    AZoomOut() {
      this.AnswerThickChange = --this.a_thick;
    },
    AZoomIn() {
      this.AnswerThickChange = ++this.a_thick;
    },
    LZoomOut() {
      this.LogoSizeChange = --this.logo_size;
    },
    LZoomIn() {
      this.LogoSizeChange = ++this.logo_size;
    },
    BZoomOut() {
      this.BannerSizeChange = --this.banner_size;
    },
    BZoomIn() {
      this.BannerSizeChange = ++this.banner_size;
    },
    LogoImage() {
      this.webform_theme.logo = false;
      for (const key in this.$refs.logoimage.files) {
        if (Object.hasOwnProperty.call(this.$refs.logoimage.files, key)) {
          const element = this.$refs.logoimage.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}-logo/question/`
            );
            formData.append("fileName", `${new Date().getTime()}-logo-`);
            vm.$store.dispatch("UploadFormData", formData).then((req) => {
              this.webform_theme.logo = true;
              // this.$refs.cropimage.ResetImage();
              vm.webform_theme.logo_image.url = req.data;
              vm.webform_theme.logo_type = this.logo_type_selected;
              getBase64FromUrl(req.data).then((result) => {
                this.imgURL = result;
              });
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
            }).then(() => {
              this.$refs.logoimage.type = "text";
              this.$refs.logoimage.type = "file";
            });
          }
        }
      }

      this.$refs.logoimage.type = "text";
      this.$refs.logoimage.type = "file";
    },
    BGImage() {
      for (const key in this.$refs.bgimage.files) {
        if (Object.hasOwnProperty.call(this.$refs.bgimage.files, key)) {
          const element = this.$refs.bgimage.files[key];
          if (/\.(jpe?g|png|gif|svg)$/i.test(element.name)) {
            let vm = this;
            let formData = new FormData();
            formData.append("fileMax", 3);
            formData.append("fileData", element);
            formData.append(
              "filePath",
              `survey/${vm.$route.params.surveyID}-bgimage/question/`
            );
            formData.append("fileName", `${new Date().getTime()}-logo-`);
            vm.$store.dispatch("UploadFormData", formData).then((req) => {
              vm.webform_theme.bg_image = true;
              vm.webform_theme.bg_image_url = req.data
                .replace(/ /g, "%20")
                .replace(/\(/g, "%28")
                .replace(/\)/g, "%29");
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่รูปภาพเท่านั้น",
              text: "รองรับ jpg, jpeg, png, gif, svg ",
            }).then(() => {
              this.$refs.bgimage.type = "text";
              this.$refs.bgimage.type = "file";
            });
          }
        }
      }
      this.$refs.bgimage.type = "text";
      this.$refs.bgimage.type = "file";
    },
    ClearLogoImage() {
      this.webform_theme.logo = false;
      this.logo_size = 100;
      this.banner_size = 100;
      this.webform_theme.banner_size = 100;
      this.logo_type_selected = "normal";
      this.webform_theme.logo_type = "normal";
      this.webform_theme.logo_image = {
        url: "",
        size: 50,
        rounded: "circle",
        align: "center",
        margin: true,
      };
    },
    NextButtonUI() {
      let bg_color = this.webform_theme.bg_color;
      let button_bg_color = this.webform_theme.button.bg_color;
      let button_text_color = this.webform_theme.button.text_color;
      if (
        this.webform_theme.button.bt_texttype === "text" ||
        this.webform_theme.button.bt_texttype === "outlined"
      ) {
        if (
          (bg_color === button_text_color &&
            button_bg_color !== button_text_color) ||
          bg_color === "#FBFBFBFF"
        ) {
          this.webform_theme.button.text_color = button_bg_color;
        }
      } else {
        if (this.webform_theme.button.text_color === button_bg_color) {
          this.webform_theme.button.text_color = bg_color;
        }
      }
    },
    BackButtonUI() {
      let bg_color = this.webform_theme.bg_color;
      let button_bg_color = this.webform_theme.restart_button.bg_color;
      let button_text_color = this.webform_theme.restart_button.text_color;
      if (
        this.webform_theme.restart_button.bt_texttype === "text" ||
        this.webform_theme.restart_button.bt_texttype === "outlined"
      ) {
        if (
          (bg_color === button_text_color &&
            button_bg_color !== button_text_color) ||
          bg_color === "#FBFBFBFF"
        ) {
          this.webform_theme.restart_button.text_color = button_bg_color;
        }
      } else {
        if (this.webform_theme.restart_button.text_color === button_bg_color) {
          this.webform_theme.restart_button.text_color = bg_color;
        }
      }
    },
  },
};
</script>

<style scoped>
.custom-panel >>> .v-expansion-panel-content__wrap {
  padding-right: 14px;
  padding-left: 12px;
}
</style>
